import { createContext, useContext } from "react";
export var BreakpointIndexContext = createContext(0);
export var useBreakpointIndex = function() {
    return useContext(BreakpointIndexContext);
};
